import { ChangeDetectionStrategy, Component } from '@angular/core';
import { atxIsMobile$ } from '@epicuro-next/ataraxia/breakpoint';
import {
  PulseConfigurationKeys,
  PULSE_FEATURE_NAME,
} from '@epicuro-next/constants/rule-engine/pulse-rules';
import { Subject } from 'rxjs';

@Component({
  selector: 'epc-main-navigation',
  templateUrl: './main-navigation.component.html',
  styleUrls: ['./main-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MainNavigationComponent {
  public isMobile$ = atxIsMobile$;
  public pulseNamespace = PULSE_FEATURE_NAME;
  public bannerEnabledFeatureKey = PulseConfigurationKeys.BannerEnabled;

  private destroy$ = new Subject<void>();

  ngOnDestroy() {
    this.destroy$.next();
  }
}
